// This icon file is generated automatically.
var PDeleteOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.63.88H3.5c.07 0 .13-.06.13-.13v.13h4.75V.74c0 .07.05.13.12.13h-.13V2H9.5V.75a1 1 0 00-1-1h-5a1 1 0 00-1 1V2h1.13V.87zM11.5 2H.5a.5.5 0 00-.5.5V3c0 .07.06.13.13.13h.94l.38 8.17a1 1 0 001 .95h7.1a1 1 0 001-.95l.38-8.18h.95c.06 0 .12-.05.12-.12v-.5a.5.5 0 00-.5-.5zm-2.07 9.13H2.57l-.37-8h7.6l-.37 8z", "fill-rule": "nonzero" } }] }, "name": "p-delete", "theme": "outlined" };
export default PDeleteOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDeleteOutlined.js
// module id = 3320
// module chunks = 0